/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2020 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


export const ACTION_TYPES = {
  SET_IES_USERID: 'SET_IES_USERID',
  FETCH_USER_DATA: 'FETCH_USER_DATA',
  SET_IES_INFO: 'SET_IES_INFO',
  FETCH_ASSESSMENT_DETAILS: 'FETCH_ASSESSMENT_DETAILS',
  FETCH_ASSESSMENTS: 'FETCH_ASSESSMENTS',
  FETCH_SUBJECTS:'FETCH_SUBJECTS',
  FETCH_COURSE:'FETCH_COURSE',
  FETCH_YEARGROUP:'FETCH_YEARGROUP',
  FETCH_STUDENTS: 'FETCH_STUDENTS',
  FETCH_ALL_STUDENTS: 'FETCH_ALL_STUDENTS',
  FETCH_STUDENT_DETAILS:'FETCH_STUDENT_DETAILS',
  GROUP_YEAR_CHANGE: 'GROUP_YEAR_CHANGE',
  FETCH_ALL_GROUP: 'FETCH_ALL_GROUP',
  FETCH_STUDENT_ASSESSMENT_DETAILS:'FETCH_STUDENT_ASSESSMENT_DETAILS',
  FETCH_GROUP: 'FETCH_GROUP',
  FETCH_STUDENT_GROUPS: 'FETCH_STUDENT_GROUPS',
  FETCH_GROUP_DETAIL:'FETCH_GROUP_DETAIL',
  FETCH_BASICASSESSMENT_DETAILS: 'FETCH_BASICASSESSMENT_DETAILS',
  FETCH_STUDENT_BASELINE: 'FETCH_STUDENT_BASELINE',
  IMPERSONATE_ACTIVATE:'IMPERSONATE_ACTIVATE',
  IMPERSONATE_DEACTIVATE: 'IMPERSONATE_DEACTIVATE',
  FETCH_ACADEMIC_YEAR: 'FETCH_ACADEMIC_YEAR',
  FETCH_FUSION_DATA:'FETCH_FUSION_DATA'
 }